export enum ReportType {
    'ProductReport' = 1,
    'ColumnReport' = 2,
    'RepairInProgress' = 3,
     UnitsPerMonth = 4,
    UnitsPerMonthByProductType = 5,
  AverageTimeInStatus = 6
}

export enum ExportType {
    CSV = 1,
    Excel = 2
}